import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Swiftdzireonrentinpune() {



  const cardData =
  {
    keyword: ' Swift Dzire On Rent in Pune',
    heading: 'Sai Trupti Cabs: Swift Dzire On Rent in Pune',
    headingDescription: 'Looking to rent a car in Pune? Our Swift Dzire on-rent service offers a perfect blend of comfort, reliability and affordability. Whether you need a vehicle for city sightseeing, business travel, airport pickup or an outstation trip to destinations like Lonavala, Shirdi or Aurangabad, our well-maintained AC Swift Dzire sedans are available with professional drivers and transparent pricing. You’ll enjoy spacious seating, ample luggage space, fuel-efficient performance and prompt, safe service throughout your journey. With 24 × 7 support, flexible booking options (hourly, daily or longer), and no hidden costs, booking a Swift Dzire in Pune has never been easier or more worry-free.',

    top: 'Top Places to Visit in Pune with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas as the seat of their empire. Once a magnificent seven-storey palace, its grand gates, carved teak balconies, and sprawling courtyards reflect royal elegance and political power. Though much of it was destroyed by fire, the fort’s ruins still whisper tales of valor, intrigue, and sacrifice. The evening light-and-sound show revives the Peshwa era through mesmerizing narration and music. Shaniwar Wada remains the emotional heart of Pune — where history, culture, and pride unite."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace stands as an enduring symbol of India’s freedom movement and Mahatma Gandhi’s legacy. Built in 1892 by Sultan Aga Khan III, the palace later became a place of internment for Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. The tranquil gardens, memorials, and museum preserve their memories and personal belongings. Its elegant Italian arches and serene ambiance make it both a historical monument and a place of reflection. Every corner tells a story of sacrifice, resilience, and the unbreakable spirit of India’s struggle for independence."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop the rugged Sahyadri ranges, Sinhagad Fort is a timeless symbol of Maratha courage and pride. The fort gained fame after the legendary battle led by Tanaji Malusare under the command of Chhatrapati Shivaji Maharaj. Trekking up its steep slopes rewards visitors with panoramic views of the valley and Pune city. The fort’s stone walls, ancient gates, and rustic stalls serving pithla-bhakri bring history to life. Sinhagad is not just a fortress — it’s an experience of heritage, adventure, and the indomitable spirit of the Marathas."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is a fascinating 8th-century rock-cut shrine carved from basalt, dedicated to Lord Shiva. Located in the heart of Pune, it offers a peaceful escape from city noise and chaos. The circular Nandi mandapa, massive stone pillars, and unfinished sanctum reflect remarkable ancient craftsmanship. Believed to have been excavated during the Rashtrakuta dynasty, the temple’s spiritual aura attracts devotees and historians alike. Amid modern Pune’s growth, Pataleshwar stands as a reminder of its deep and timeless spiritual roots."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering both divine blessings and breathtaking views. The temple complex atop the hill is dedicated to Lord Shiva and Goddess Parvati and was built by the Peshwas in the 18th century. Climbing its 108 stone steps is both a spiritual and meditative experience, rewarded by panoramic views of the city below. The site also houses the Peshwa Museum, which preserves rare artifacts of Maratha glory. At sunrise and sunset, Parvati Hill becomes a golden haven of peace, history, and devotion."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most beloved spiritual landmark, drawing millions of devotees each year. The temple’s magnificent idol of Lord Ganesha, adorned with gold ornaments and fresh flowers, radiates devotion and positivity. During Ganesh Chaturthi, the entire area transforms into a festival of lights, music, and prayer. The temple also supports charitable causes, embodying the true essence of faith in action. Whether you visit for blessings or simply to soak in its energy, Dagdusheth Temple fills every heart with peace and joy."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of Indian art and tradition, housing over 20,000 artifacts collected by the late Dr. Dinkar Kelkar. Its exhibits include intricate musical instruments, ancient sculptures, traditional ornaments, and everyday objects that reveal India’s creative spirit. The museum’s highlight is the replica of a 17th-century Wada — a traditional Maharashtrian mansion. Walking through its corridors feels like stepping back in time. It’s a must-visit for art lovers, history enthusiasts, and anyone seeking to rediscover India’s cultural richness."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, just 20 km from Pune, is a popular getaway surrounded by rolling hills and lush greenery. Built across the Mutha River, it serves as the city’s primary water source and a serene picnic spot for families and friends. Visitors enjoy the mesmerizing sunset reflecting off the calm waters while savoring local snacks from nearby stalls. During monsoon, the dam’s scenic charm doubles, making it a photographer’s paradise. It’s the perfect escape for those seeking peace, nature, and a cool breeze away from urban life."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a tranquil oasis that attracts visitors from across the globe. Spread over lush gardens and modern Zen-inspired architecture, it offers various meditation sessions, wellness therapies, and workshops on mindfulness. The serene environment encourages introspection and personal growth. Beyond being a retreat, Osho Resort reflects Pune’s cosmopolitan identity — blending spirituality, modernity, and holistic living. It’s where silence meets luxury, creating an experience that rejuvenates both body and soul."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "Inspired by Japan’s famous Korakuen Garden, the Pune Okayama Friendship Garden — also known as Pu La Deshpande Udyan — is an exquisite symbol of Indo-Japanese friendship. Spread across 10 acres, its winding paths, small bridges, ponds, and manicured lawns create a serene landscape ideal for relaxation and photography. The garden’s harmony between Japanese design and Indian flora makes it one of Pune’s most aesthetic green spaces. Families, nature lovers, and photographers visit to unwind amid its calming beauty and artistic symmetry."
  }
],



"services": [
    {
      "name": "Swift Dzire On Rent in Pune",
      "description": "Rent a Swift Dzire in Pune for daily, weekly, or long-term use with fully maintained vehicles and professional drivers. Ideal for city travel, airport transfers, business trips, sightseeing, or personal errands. Enjoy comfortable seating, AC and non-AC options, flexible pickup and drop points, real-time tracking, transparent fares, and excellent customer support for a hassle-free rental experience."
    },
    {
      "name": "Swift Dzire Hire Pune",
      "description": "Swift Dzire hire service in Pune offers convenient, reliable, and comfortable transportation for solo travelers, families, and groups. Choose from AC and non-AC options, one-way or round trips, and flexible booking schedules. Professional drivers, well-maintained vehicles, luggage assistance, and door-to-door service make every journey stress-free and enjoyable."
    },
    {
      "name": "Swift Dzire Car Rental Pune",
      "description": "Swift Dzire car rental in Pune provides a perfect solution for local travel, corporate trips, and outstation journeys. With modern AC cars, experienced drivers, flexible rental hours, transparent pricing, secure online booking, and excellent customer service, you can travel comfortably, safely, and affordably across Pune and nearby regions."
    },
    {
      "name": "Swift Dzire AC Cab Pune",
      "description": "AC Swift Dzire cab service in Pune ensures a cool and comfortable ride for business or leisure travel. Professional drivers, door-to-door pickup, luggage handling, and well-maintained vehicles provide a seamless travel experience. Suitable for airport transfers, city tours, family outings, and long-distance travel with comfort, safety, and reliability."
    },
    {
      "name": "Swift Dzire Non AC Cab Pune",
      "description": "Non-AC Swift Dzire cab service in Pune offers budget-friendly travel without compromising comfort and safety. Ideal for daily commutes, local sightseeing, or small group trips. Features include professional drivers, point-to-point service, luggage support, punctual pickups, transparent pricing, and well-maintained vehicles for a reliable and smooth journey."
    },
    {
      "name": "Swift Dzire One Way Rental Pune",
      "description": "Swift Dzire one-way rental in Pune provides efficient point-to-point travel for travelers who need direct, time-saving transportation. Perfect for airport transfers, business trips, or short-distance travel. Includes professional drivers, AC and non-AC options, luggage handling, flexible pickup/drop points, and transparent fares for a hassle-free experience."
    },
    {
      "name": "Swift Dzire Outstation Rental Pune",
      "description": "Outstation Swift Dzire rental in Pune offers comfortable and safe travel for long-distance trips. Perfect for weekend getaways, pilgrimages, family trips, and corporate travel. Services include professional drivers, toll coverage, luggage assistance, AC/non-AC options, flexible scheduling, well-maintained vehicles, and transparent fares ensuring a smooth and enjoyable journey."
    },
    {
      "name": "Swift Dzire Local Hire Pune",
      "description": "Swift Dzire local hire in Pune provides hourly rental options for city travel, errands, and sightseeing. AC and non-AC cars available with professional drivers. Services include door-to-door pickup, real-time tracking, flexible rental hours, luggage assistance, and reliable vehicles to ensure comfort, safety, and convenience for short trips around the city."
    },
    {
      "name": "Swift Dzire Taxi Service Pune",
      "description": "Swift Dzire taxi service in Pune delivers convenient and reliable transportation for daily travel, airport transfers, and long-distance journeys. Features include AC/non-AC options, professional drivers, well-maintained vehicles, flexible pickup/drop points, luggage assistance, transparent pricing, online booking, and a safe, stress-free, and comfortable ride."
    },
    {
      "name": "Affordable Swift Dzire Rental Pune",
      "description": "Budget-friendly Swift Dzire rental service in Pune offering safe, reliable, and comfortable travel for families, groups, and solo travelers. Includes AC/non-AC cars, professional drivers, transparent fares, door-to-door service, luggage assistance, flexible scheduling, and well-maintained vehicles, ensuring cost-effective and convenient travel across Pune and nearby destinations."
    },
    {
      "name": "Swift Dzire Luxury Cab Pune",
      "description": "Luxury Swift Dzire cab rental in Pune provides premium comfort and style for corporate travel, special occasions, or VIP trips. Features AC service, professional chauffeurs, well-maintained vehicles, luggage support, flexible scheduling, punctual pickups, and transparent fares. Perfect for travelers seeking elegance, convenience, and a smooth, safe, and high-end journey."
    },
    {
      "name": "Swift Dzire Online Booking Pune",
      "description": "Book Swift Dzire cabs in Pune online instantly with multiple vehicle options, secure payments, flexible scheduling, and real-time tracking. Ideal for local travel, airport transfers, corporate trips, or long-distance journeys. Services include AC/non-AC vehicles, professional drivers, luggage support, transparent fares, and a hassle-free, convenient, and reliable booking experience."
    },
    {
      "name": "Swift Dzire Corporate Hire Pune",
      "description": "Swift Dzire corporate hire service in Pune offers comfortable, reliable, and professional transportation for business executives, corporate events, meetings, and airport transfers. Includes AC vehicles, professional chauffeurs, luggage assistance, punctual service, flexible scheduling, transparent fares, and a smooth, safe, and stress-free ride to ensure productivity and convenience for corporate clients."
    },
    {
      "name": "Swift Dzire Wedding Rental Pune",
      "description": "Swift Dzire wedding rental in Pune provides stylish and comfortable transportation for weddings, receptions, and special occasions. AC vehicles with professional drivers, well-maintained interiors, flexible pickup and drop points, luggage support, transparent pricing, and timely service ensure that families, wedding parties, and guests experience a convenient, safe, and luxurious ride."
    },
    {
      "name": "Swift Dzire Rental Near Me Pune",
      "description": "Find Swift Dzire rentals near your location in Pune for quick and convenient booking. Features include AC and non-AC vehicles, professional drivers, flexible pickup and drop points, luggage assistance, transparent fares, and reliable service. Perfect for local travel, airport transfers, corporate trips, and long-distance journeys, ensuring a hassle-free and comfortable experience."
    }
  ],
  "tableData": [
    ["Swift Dzire On Rent in Pune", "Swift Dzire Hire Pune"],
    ["Swift Dzire Car Rental Pune", "Swift Dzire AC Cab Pune"],
    ["Swift Dzire Non AC Cab Pune", "Swift Dzire One Way Rental Pune"],
    ["Swift Dzire Outstation Rental Pune", "Swift Dzire Local Hire Pune"],
    ["Swift Dzire Taxi Service Pune", "Affordable Swift Dzire Rental Pune"],
    ["Swift Dzire Luxury Cab Pune", "Swift Dzire Online Booking Pune"],
    ["Swift Dzire Corporate Hire Pune", "Swift Dzire Wedding Rental Pune"],
    ["Swift Dzire Rental Near Me Pune", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Swift Dzire On Rent in Pune",
    "WhyChoosedescription": "Sai Trupti Cabs Pvt Ltd offers reliable and comfortable Swift Dzire rental services in Pune—ideal for city travel, airport transfers, outstation trips, or leisure drives."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Our Swift Dzire rental fares in Pune start from approx. ₹1,999/day for self‑drive and ₹12/km for chauffeur‑driven trips, depending on distance, duration, and vehicle type. :contentReference[oaicite:1]{index=1}"
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "We offer well-maintained Swift Dzire cars with air conditioning and comfortable seating—suitable for solo travelers, families, or small groups. :contentReference[oaicite:2]{index=2}"
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "If you choose a chauffeur-driven option, our courteous and skilled drivers ensure a safe, smooth, and timely journey throughout Pune and nearby routes."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We provide convenient pickup and drop-off anywhere in Pune, including airports, railway stations, hotels, or your preferred locations."
  },
  {
    "WhyChooseheading": "Clean, Well-Maintained Vehicles",
    "WhyChoosedescription": "All Swift Dzire vehicles are regularly serviced, sanitized, and maintained to guarantee comfort, reliability, and safety during your travel."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, travel planning, or any changes in your rental schedule."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Swift Dzire rental in Pune easily via call, WhatsApp, or our website—with instant confirmation and prompt vehicle dispatch."
  }
]

























  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Swift Dzire on rent in Pune?',
    answer: 'Yes, Sai Trupti Cabs  offers the Swift Dzire on rent in Pune for city trips, outstation travel, airport transfers and more.',
  },
  {
    question: 'How can I rent a Swift Dzire in Pune with Sai Trupti Cabs?',
    answer: 'You can easily book a Swift Dzire through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of rental packages are available for the Swift Dzire in Pune?',
    answer: 'We provide flexible rental packages for the Swift Dzire including hourly, full‑day, and outstation options to suit your travel needs.',
  },
  {
    question: 'What are typical rental rates for the Swift Dzire in Pune?',
    answer: 'Our Swift Dzire rentals in Pune are priced around ₹ 12–₹ 15 per km for outstation trips and from about ₹ 2,500 for a full‑day local rental (8 hours / 80 km), depending on package and vehicle condition.',
  },
  {
    question: 'What payment methods are accepted for Swift Dzire rental bookings?',
    answer: 'We accept UPI, credit/debit cards, bank transfers and digital wallets for hassle‑free transactions.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Swift Dzire rentals?',
    answer: 'All our Swift Dzire cars are well‑maintained, sanitized before every trip and driven by trained professional drivers to ensure a safe and comfortable journey.',
  },
  {
    question: 'Is customer support available during the Swift Dzire rental period?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Swift Dzire rental period in Pune.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Kulkarni',
    feedback: 'Rented a Swift Dzire in Pune from Sai Trupti Cabs — the ride was smooth and the driver punctual. Very satisfied!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Pooja Patwardhan',
    feedback: 'Swift Dzire rental with Sai Trupti Cabs was a seamless experience. Good car, clean interior and friendly driver.',
    rating: 5,
  },
];


































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Swift Dzire On Rent in Pune",
  "image": "https://saitrupticabs.com/assets/images/swift-dzire-pune.jpg",
  "description": "Rent a Swift Dzire in Pune with Sai Trupti Cabs for a safe, comfortable, and affordable journey. Choose AC or Non-AC options for one-way, local, outstation, corporate, or special occasion travel with verified drivers and 24/7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "15864"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "999",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/swift-dzire-on-rent-pune"
  }
};





  return (
    <div>
      
<Helmet>
  <title>Swift Dzire On Rent in Pune | Affordable & Comfortable | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Rent a Swift Dzire in Pune with Sai Trupti Cabs for a safe, comfortable, and affordable journey. Choose AC or Non-AC options for one-way, local, outstation, corporate, or special occasion travel with verified drivers and 24/7 online booking." 
  />
  <meta 
    name="keywords" 
    content="Swift Dzire On Rent in Pune, Swift Dzire Hire Pune, Swift Dzire Car Rental Pune, Swift Dzire AC Cab Pune, Swift Dzire Non AC Cab Pune, Swift Dzire One Way Rental Pune, Swift Dzire Outstation Rental Pune, Swift Dzire Local Hire Pune, Swift Dzire Taxi Service Pune, Affordable Swift Dzire Rental Pune, Swift Dzire Luxury Cab Pune, Swift Dzire Online Booking Pune, Swift Dzire Corporate Hire Pune, Swift Dzire Wedding Rental Pune, Swift Dzire Rental Near Me Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/64.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Swiftdzireonrentinpune;